<span *ngIf="svg" [innerHTML]="svgContent"></span>
